import {
    RouterProvider,
    Outlet,
    createHashRouter
} from 'react-router-dom';
import './App.css';

import Generate from "./containers/Generate";
import React, { useEffect, useState } from "react";
import NavigationMenu from "./components/NavigationMenu";
import MyCollection from "./containers/MyCollection";
import Settings from "./containers/Settings";
import { GenerateProvider } from "./context/GenerateContext";
import { PromptusAPIProvider } from "./context/PromptusAPIContext";
import { db } from "./db";
import Profile from "./containers/Profile";
import Explore from "./containers/Explore";
import HowTo from "./containers/HowTo";
import Chat from "./containers/Chat";
import { DriverProvider } from './context/DriverContext';
import { CollectionProvider } from './context/CollectionContext';
import { AccountProvider } from './context/AccountContext';
import Marketplace from './containers/Marketplace';
import { isUndefined } from 'cropperjs';
import { PromptProvider } from './context/PromptContext';
import {SettingsProvider} from "./context/SettingsContext";
import ComfyUI from './containers/ComfyUI';

const MainLayout = () => {
    return (
        <>
            <div className="flex flex-col md:flex-row min-h-screen w-full text-white">
                <GenerateProvider>
                    <PromptusAPIProvider>
                        <DriverProvider>
                            <CollectionProvider>
                                <AccountProvider>
                                    <PromptProvider>
                                        <SettingsProvider>
                                            <NavigationMenu />

                                            <main className="flex-grow max-w-full min-h-screen container">
                                                <Outlet />
                                            </main>
                                        </SettingsProvider>
                                    </PromptProvider>
                                </AccountProvider>
                            </CollectionProvider>
                        </DriverProvider>
                    </PromptusAPIProvider>
                </GenerateProvider>
            </div>
        </>
    );
};

const getChatSetting = async () => {
    const setting = await db.settings.get({ key: 'use_aihorde_models' });
    return setting ? setting.value === true : false;
};

const router = createHashRouter([
    {
        element: <MainLayout/>,
        children: [
            {
                path: "/",
                element: <Generate />,
            },
            {
                path: "/my-collection",
                element: <MyCollection />
            },
            {
                path: "/settings",
                element: <Settings />
            },
            {
                path: "/profile",
                element: <Profile />
            },
            {
                path: "/explore",
                element: <Explore />
            },
            {
                path: "/how-to",
                element: <HowTo />
            },
            {
                path: "/marketplace",
                element: <Marketplace />
            },
            {
                path: "/chat",
                element: <Chat />
            },
            {
                path: "/comfyui",
                element: <ComfyUI/>
            }
        ]
    }
]);

function App() {

    db.settings.where('key').equals('low_memory').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'low_memory', value: true });
        }
    });
    db.settings.where('key').equals('safe_mode').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'safe_mode', value: true });
        }
    });
    db.settings.where('key').equals('test_mode').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'test_mode', value: false });
        }
    });
    db.settings.where('key').equals('play_sounds').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'play_sounds', value: true });
        }
    });
    db.settings.where('key').equals('full_precision').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'full_precision', value: false });
        }
    });
    db.settings.where('key').equals('half_model').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'half_model', value: false });
        }
    });
    db.settings.where('key').equals('cpu_generation').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'cpu_generation', value: false });
        }
    });
    db.settings.where('key').equals('cpu_offloading').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'cpu_offloading', value: false });
        }
    });
    db.settings.where('key').equals('category_popup').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'category_popup', value: true });
        }
    });
    db.settings.where('key').equals('use_openai_models').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'use_openai_models', value: false });
        }
    });
    db.settings.where('key').equals('use_aihorde_models').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'use_aihorde_models', value: false });
        }
    });
    db.settings.where('key').equals('auto_recovery').first((setting) => {
        if (isUndefined(setting)) {
            db.settings.put({ key: 'auto_recovery', value: true });
        }
    });
    
    if (!localStorage.getItem('remember_workload')) {
        localStorage.setItem('remember_workload', JSON.stringify({
            active: false,
            uid: "",
            count: 0,
            totalImage: 0,
            num: 0,
        }))
    }    

    if (!router) {
        return null; // or some loading indicator
    }

    return <RouterProvider router={router} />;
}

export default App;
